export function BoldCheckIcon({ fillCheckmark = false }: { fillCheckmark?: boolean }) {
	if (fillCheckmark) {
		return (
			<svg
				width="14px"
				height="14px"
				viewBox="0 0 14 14"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Group">
						<path
							d="M7,14 C10.866,14 14,10.866 14,7 C14,3.13401 10.866,0 7,0 C3.13401,0 0,3.13401 0,7 C0,10.866 3.13401,14 7,14 Z"
							id="Subtract"
							fill="currentColor"
						>
						</path>
						<path
							d="M10.5028,5.21852 C10.7615,4.89507 10.7091,4.42311 10.3856,4.16435 C10.0622,3.90559 9.59022,3.95803 9.33146,4.28148 L5.78557,8.71384 L4.36711,7.65 C4.03574,7.40147 3.56564,7.46863 3.31711,7.8 C3.06859,8.13137 3.13574,8.60147 3.46711,8.85 L5.46711,10.35 C5.79119,10.5931 6.24971,10.5348 6.50277,10.2185 L10.5028,5.21852 Z"
							id="Subtract-path"
							fill="white"
						>
						</path>
					</g>
				</g>
			</svg>
		)
	} else {
		return (
			<>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 14 14"
					id="Check-Circle--Streamline-Core"
					height={14}
					width={14}
				>
					<g id="check-circle--checkmark-addition-circle-success-check-validation-add-form-tick">
						<path
							id="Subtract"
							fill="currentColor"
							fillRule="evenodd"
							d="M7 14c3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7 -3.86599 0 -7 3.13401 -7 7 0 3.866 3.13401 7 7 7Zm3.5028 -8.78148c0.2587 -0.32345 0.2063 -0.79541 -0.1172 -1.05417 -0.3234 -0.25876 -0.79538 -0.20632 -1.05414 0.11713L5.78557 8.71384 4.36711 7.65c-0.33137 -0.24853 -0.80147 -0.18137 -1.05 0.15 -0.24852 0.33137 -0.18137 0.80147 0.15 1.05l2 1.5c0.32408 0.2431 0.7826 0.1848 1.03566 -0.1315l4.00003 -4.99998Z"
							clipRule="evenodd"
							strokeWidth={1}
						/>
					</g>
				</svg>
			</>
		)
	}
}
